import React from "react";
import { Link } from "react-router-dom";
import "../../App.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
const Footer = () => {
  return (
    <section className="section footer bg-dark text-white hello ">
      <div className="container ">
        <div className="row">
          <div className="col-md-4">
            <br />
            <h6>Company Information</h6>
            <hr />
            <p>
              A.A. Smart Jet Technology Focuses On Market-Leading Service,
              Forward Thinking Product Offerings And Putting Our Customer’s
              Current And Future Needs At The Forefront Of Any Business
              Developments. All Types of CIJ & TIJ Printers Service & Consumable
              Like Ink.
            </p>
          </div>
          <div className="col-md-4">
            <br />
            <h6>Quick Links</h6>
            <hr />
            <div>
              <Link to="/">Home</Link>
            </div>
            <div>
              <Link to="/about">About Us</Link>
            </div>
            <div>
              <Link to="/allproduct">Products</Link>
            </div>
            <div>
              <Link to="/Contact">Contact Us</Link>
            </div>
            <div>
              <Link to="/admin-dashboard">Admin Dashboard</Link>
            </div>
            <div className="social">
              <a href="https://www.facebook.com/share/z2qbsDwJGPUPrD6C/?mibextid=qi2Omg" className="text-white">
                <i className="fab fa-facebook"></i>
              </a>

              <a href="https://www.linkedin.com/company/a-a-smart-jet-technology/posts/?feedView=all" className="text-white">
                <i className="fab fa-linkedin"></i>
              </a>

              <a href="https://www.instagram.com/aasmartjet12?utm_source=qr&igsh=MTc1bjV3aXdtNmVwOQ==" className="text-white">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <br />
            <h6>Contact Information</h6>
            <hr />
            <div className="text-white mb-1">
              <p>Chhatrapati Sambhaji Nagar, Maharashtra, India</p>
            </div>
            <div className="text-white mb-1">
              <p>+91 9657579144</p>
            </div>
            <div className="text-white mb-1">
              <p>smartjet96@gmail.com</p>
            </div>
            <div>
              <Link
                to="/Contact"
                style={{
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  style={{ marginRight: "8px" }}
                />
                Location
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
